module.exports = __webpack_public_path__ + "icon-home.png?aef526907d150a84f8c09513fdde8ebc";


//////////////////
// WEBPACK FOOTER
// ./Content/img/icon-home.png
// module id = 842
// module chunks = 1